var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.158 5.667L9 7.825 6.84 5.667 5.667 6.842 7.825 9l-2.159 2.158 1.175 1.175L9 10.175l2.158 2.158 1.175-1.175L10.175 9l2.158-2.158-1.175-1.175zM9 .667A8.326 8.326 0 00.667 9 8.326 8.326 0 009 17.333 8.326 8.326 0 0017.333 9 8.326 8.326 0 009 .667zm0 15A6.675 6.675 0 012.333 9 6.676 6.676 0 019 2.333 6.676 6.676 0 0115.666 9 6.675 6.675 0 019 15.667z",
    fill: "#fff"
  })));
}
export default SvgCrossCircle;